// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1Uybs","n":"Logo_n__1_ScN","e":"Logo_e__9fegi","t":"Logo_t__1N_eK","f":"Logo_f__2zusE","l":"Logo_l__2bQLj","i":"Logo_i__3C0gW","x":"Logo_x__1XSFC"};